module.exports = __webpack_public_path__ + "media/images/sandbox/rondell/rondell-1-6eb97e5a535a517d2816cb1193302893.jpg";